
import { Component, Prop, Vue } from "vue-property-decorator";
import dayjs from "dayjs";
import { emptyToLine } from "@common/src/utils/common";
import { namespace } from "vuex-class";

const store = namespace("store");

@Component({})
export default class TestOrderPrint extends Vue {
  @store.State storeData;
  @Prop({ default: () => {} })
  data: any;
  dayjs = dayjs;
  emptyToLine = emptyToLine;
  get $data() {
    this.data.warningDetails = this.data.warningDetails || [];
    return this.data;
  }
}
